import React, { FunctionComponent, Fragment } from "react";
import { Typography, Avatar } from "@material-ui/core";
import "./index.scss";

type QuoteProps = {
  text?: string | null;
  title?: string | null;
  subTitle?: string | null;
  avatar?: string | null;
};

export const Quote: FunctionComponent<QuoteProps> = ({
  text,
  title,
  subTitle,
  avatar,
}) => {
  return (
    <Fragment>
      <div className="component--quote">
        {title && (
          <Fragment>
            <Typography variant="h4" component="blockquote" className="text">
              {text}
            </Typography>
            {avatar && avatar !== null && (
              <Avatar
                variant="circle"
                className="avatar"
                alt={title}
                src={avatar}
              />
            )}
            <Typography variant="body1" component="p" className="title">
              {title}
            </Typography>
            <Typography variant="body1" component="p" className="subtitle">
              {subTitle}
            </Typography>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};
export default Quote;
